import { formatMacro, macroPercent } from '@/lib/utils'

interface MacroBarProps {
  label: string
  value: number
  target: number | null
  unit?: string
  color: string
}

export function MacroBar({ label, value, target, unit = 'g', color }: MacroBarProps) {
  const pct = macroPercent(value, target)
  const over = target ? value > target * 1.05 : false

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between text-xs">
        <span className="font-medium text-gray-600">{label}</span>
        <span className={`font-semibold ${over ? 'text-red-600' : 'text-gray-800'}`}>
          {formatMacro(value, unit)}
          {target ? <span className="font-normal text-gray-400"> / {formatMacro(target, unit)}</span> : null}
        </span>
      </div>
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-300 ${over ? 'bg-red-500' : color}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}

interface MacroBadgeRowProps {
  calories: number | null
  protein_g: number | null
  carbs_g: number | null
  fat_g: number | null
  compact?: boolean
}

export function MacroBadgeRow({ calories, protein_g, carbs_g, fat_g, compact }: MacroBadgeRowProps) {
  if (!calories && !protein_g) return null
  return (
    <div className={`flex gap-2 flex-wrap ${compact ? 'text-[10px]' : 'text-xs'}`}>
      {calories != null && (
        <span className="bg-orange-50 text-orange-700 px-1.5 py-0.5 rounded font-medium">
          {Math.round(calories)} kcal
        </span>
      )}
      {protein_g != null && (
        <span className="bg-blue-50 text-blue-700 px-1.5 py-0.5 rounded font-medium">
          P {Math.round(protein_g)}g
        </span>
      )}
      {carbs_g != null && (
        <span className="bg-yellow-50 text-yellow-700 px-1.5 py-0.5 rounded font-medium">
          C {Math.round(carbs_g)}g
        </span>
      )}
      {fat_g != null && (
        <span className="bg-purple-50 text-purple-700 px-1.5 py-0.5 rounded font-medium">
          F {Math.round(fat_g)}g
        </span>
      )}
    </div>
  )
}
